import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { KeycloakProvider } from '../KeycloakAuth/KeycloakWrapper';
import { AppContextData } from '../AppContext';
import { Loader } from '../../components/Loader/Loader';

function KeycloakLandingProxy () {
  const { state } = useContext(AppContextData);
  const location = useLocation();
  const navigate = useNavigate();

  const keycloakConfig =
    location.state?.authTypeResponse || state?.authTypeResponse;

  useEffect(() => {
    if (!keycloakConfig && !state.isLoading) {
      navigate('/', { replace: true });
    }
  }, [keycloakConfig, state.isLoading, navigate]);

  if (!keycloakConfig) {
    return <Loader type="fullScreen" />;
  }

  return (
    <KeycloakProvider
      state={location.state}
      authType={keycloakConfig}
    />
  );
}

export const KeycloakLanding = KeycloakLandingProxy;
